"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Position = void 0;
/** A position on the globe. */
var Position = /** @class */ (function () {
    /** Create a new Positon object with latitude, longitude and altitude. */
    function Position(latitude, longitude, altitude) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.altitude = altitude;
    }
    return Position;
}());
exports.Position = Position;
//# sourceMappingURL=Position.js.map